import {
    DateInput,
    ReferenceInput,
    required,
    SimpleForm,
    TextInput,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaCreateView } from "../components/views/RaCreateView";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { RaAutocompleteInput } from "../components/inputs/Ra/RaAutocompleteInput";
import dayjs from "dayjs";

export const RepairOrderCreate = (props) => {
    const translate = useTranslate();
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaCreateView {...props} actions={<ToolbarWithHistory />}>
            <SimpleForm redirect="show">
                <TextInput
                    title={translate("equip.name")}
                    label="equip.name"
                    source="name"
                    validate={[required()]}
                />
                <DateInput
                    title={translate("equip.startDate")}
                    label="equip.startDate"
                    source="startDate"
                    defaultValue={dayjs()}
                    validate={[required()]}
                />
                <ReferenceInput
                    source="repairShop.id"
                    reference="repairShops"
                    sort={{ field: "name", order: "ASC" }}
                >
                    <RaAutocompleteInput
                        label="equip.repairShop"
                        validate={[required()]}
                        fullWidth
                        field="name"
                    />
                </ReferenceInput>
            </SimpleForm>
        </RaCreateView>
    );
};
